var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'base-input': true,
    'base-input-is-error': _vm.isShowError
},style:({
    flex: _vm.flex
})},[_c('el-input',_vm._g(_vm._b({ref:"elIpt"},'el-input',_vm.$attrs,false),_vm.$listeners),[_vm._t("prefix",null,{"slot":"prefix"}),_vm._t("suffix",null,{"slot":"suffix"}),_vm._t("prepend",null,{"slot":"prepend"}),_vm._t("append",null,{"slot":"append"})],2),(_vm.isShowError)?_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }